function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.33653 2.11319C7.26914 2.14532 7.21815 2.20795 7.1685 2.28904C7.11866 2.37045 7.06354 2.48212 6.99289 2.62525L6.99127 2.62854L5.62459 5.39727C5.58025 5.48712 5.56358 5.51939 5.54078 5.54392C5.51919 5.56716 5.49331 5.58598 5.46455 5.59935C5.43418 5.61348 5.39834 5.61938 5.2992 5.63388L2.24216 6.08071L2.23852 6.08124C2.08064 6.10432 1.95746 6.12232 1.86469 6.14463C1.77226 6.16685 1.69698 6.19604 1.64564 6.25024C1.56686 6.33339 1.52982 6.44765 1.54481 6.56121C1.55459 6.63522 1.59841 6.70302 1.66021 6.77525C1.72224 6.84776 1.81142 6.93462 1.92573 7.04595L1.92836 7.04851L4.13963 9.20229C4.21151 9.2723 4.2371 9.29815 4.25341 9.32746C4.26886 9.3552 4.27877 9.38568 4.28259 9.4172C4.28663 9.4505 4.28114 9.48646 4.26418 9.58536L3.74242 12.6275L3.7418 12.6311C3.71481 12.7885 3.69375 12.9112 3.68621 13.0064C3.67871 13.1012 3.68314 13.1819 3.71878 13.2475C3.77347 13.3482 3.87068 13.4188 3.98333 13.4397C4.05676 13.4533 4.13483 13.4326 4.22268 13.3961C4.31087 13.3595 4.42113 13.3015 4.56246 13.2272L4.56567 13.2255L7.29863 11.7883C7.38743 11.7416 7.41992 11.7252 7.45283 11.7188C7.48399 11.7127 7.51603 11.7127 7.54719 11.7188C7.5801 11.7252 7.61259 11.7416 7.70139 11.7883L10.4343 13.2255L10.4375 13.2272C10.5789 13.3015 10.6891 13.3595 10.7773 13.3961C10.8652 13.4326 10.9433 13.4533 11.0167 13.4397C11.1293 13.4188 11.2266 13.3482 11.2812 13.2475C11.3169 13.1819 11.3213 13.1012 11.3138 13.0064C11.3063 12.9112 11.2852 12.7884 11.2582 12.631L11.2576 12.6275L10.7358 9.58536C10.7189 9.48646 10.7134 9.4505 10.7174 9.4172C10.7213 9.38568 10.7312 9.3552 10.7466 9.32746C10.7629 9.29815 10.7885 9.2723 10.8604 9.20229L13.0717 7.04851L13.0743 7.04596C13.1886 6.93462 13.2778 6.84776 13.3398 6.77525C13.4016 6.70302 13.4454 6.63522 13.4552 6.56121C13.4702 6.44765 13.4332 6.33339 13.3544 6.25024C13.303 6.19604 13.2278 6.16685 13.1353 6.14463C13.0426 6.12232 12.9194 6.10432 12.7615 6.08124L12.7579 6.08071L9.70082 5.63388C9.60168 5.61938 9.56584 5.61348 9.53547 5.59935C9.50672 5.58598 9.48083 5.56716 9.45924 5.54392C9.43644 5.51939 9.41978 5.48712 9.37543 5.39727L8.00875 2.62854L8.00713 2.62525C7.93648 2.48212 7.88136 2.37045 7.83152 2.28904C7.78187 2.20795 7.73088 2.14532 7.66349 2.11319C7.56008 2.06388 7.43994 2.06388 7.33653 2.11319Z",
    fill: "url(#paint0_linear_5521_355)",
    stroke: "#FFD776",
    style: {
      stroke: "#FFD776",
      stroke: "color(display-p3 1.0000 0.8443 0.4637)",
      strokeOpacity: 1
    },
    strokeWidth: 0.134694
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5521_355",
    x1: 2,
    y1: 6.50004,
    x2: 13.5,
    y2: 6.50004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD776",
    style: {
      stopColor: "#FFD776",
      stopColor: "color(display-p3 1.0000 0.8443 0.4637)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818549,
    stopColor: "#FFD776",
    style: {
      stopColor: "#FFD776",
      stopColor: "color(display-p3 1.0000 0.8431 0.4627)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820027,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar01);
export default __webpack_public_path__ + "static/media/star-01.33e24b53907927f5ce013bf662b7b838.svg";
export { ForwardRef as ReactComponent };